import React, { useState } from 'react';
import { I18n } from '@td/shared_utils';

import * as utils from 'app/lib/utils';
import ProviderBasicSearchResults from './provider-basic-search-results';
import ProviderBasicSearchForm from './provider-basic-search-form';
import styles from '../styles.module.scss';

const ProviderBasicSearchIndex = ({ showOnShift }) => {
  const [searchParams, setSearchParams] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const erxRegistrationQueryParams = {
    target_host: window.ERX_REGISTRATION_HOST,
    target_path: 'providers'
  };

  const erxRegistrationPath = `/remote_sso?${new window.URLSearchParams(erxRegistrationQueryParams).toString()}`;

  return (
    <div>
      <div className="search">
        <h4>
          <I18n scope="provider.search" text="label" />
        </h4>
        <div className={styles.searchLinks}>
          <a href="/providers?advanced_provider_search=1">
            <I18n scope="provider.search" text="advanced_search_link" />
          </a>
          {utils.isFeatureToggleActive('surescripts_v6_1') && utils.isFeatureToggleActive('provider_registration_application') && (
            <a href={erxRegistrationPath}>
              <I18n scope="provider.search" text="erx_registrations_search_link" />
            </a>
          )}
        </div>
        <ProviderBasicSearchForm
          setSearchParams={setSearchParams}
          isFetching={isFetching}
          setIsFetching={setIsFetching}
          showOnShift={showOnShift}
        />
      </div>
      {searchParams && (
        <ProviderBasicSearchResults
          searchParams={searchParams}
          setIsFetching={setIsFetching}
          showOnShift={showOnShift}
        />
      )}
    </div>
  );
};

export default ProviderBasicSearchIndex;
